// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vkK3","selected":"styles_selected__t8DHR"};